import { defa } from 'defa-object';
/**
 * defa.models.LogEntry
 * The DEFA LogEntry model.
 * @version 1.2.0
 */
import Model    from 'scripts/poppet/model';

const api = {
	logs: defa.vars.apiHost + '/logs',
};

const LogEntry = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.logs,
	
	defaults: {
		
		user    : null,
		customer: null,
		unit    : null,
		
		content  : '',
		tags     : [],
		timestamp: '',
		
		transientChangee: null,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default LogEntry;